export default "__VITE_ASSET__a4944964__"